import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-attention-modal',
    templateUrl: './attention-modal.component.html',
    styleUrl: './attention-modal.component.scss',
    standalone: false,
})
export class AttentionModalComponent {
  @Input() message?: string;
  @Input() messageHtml?: string;

  @Input() buttonText?: string;
  @Input() blocking = false;
  @Input() isAlert = false;

  @Output() readonly visibleChange = new EventEmitter<boolean>();
  @Output() readonly onClicked = new EventEmitter<void>();
  @Output() readonly onDismissed = new EventEmitter<void>();
  @Output() readonly onHidden = new EventEmitter<void>();
  private _visible = false;
  @Input() 
  get visible(): boolean {
    return this._visible;
  };
  set visible(value: boolean) {
    this._visible = value;

    this.visibleChange.emit(value);
  }
  handleAction() {
    this.onClicked.emit();
    this.visible = false;
  }

  handleDismiss() {
    this.onDismissed.emit();
    this.visible = false;
  }

  handleHidden() {
    this.onHidden.emit();
    this.visible = false;
  }
}
